<span *ngIf="!state.valueAsArray && !state.valueAsSingle">-</span>

<div class="w-full aligner-start" *ngIf="state.valueAsSingle; let value">
  <div [ngSwitch]="value">
    <div *ngSwitchCase="ImportWriteType.Append" class="aligner-start">
      <y42-icon [icon]="importIcon" class="job-import incremental"></y42-icon>
      Incremental
    </div>
    <div *ngSwitchCase="ImportWriteType.Truncate" class="aligner-start">
      <y42-icon [icon]="importIcon" class="job-import full"></y42-icon>
      Full
    </div>
  </div>
</div>

<div class="w-full h-full aligner-start group-by-display" *ngIf="state.valueAsArray">
  <div *ngFor="let value of state.valueAsArray; trackBy: trackByType" class="mr-2 aligner-start">
    <div *ngIf="value.type === ImportWriteType.Append" class="aligner-start">
      <y42-icon [icon]="importIcon" class="job-import incremental"></y42-icon>
    </div>
    <div *ngIf="value.type === ImportWriteType.Truncate" class="aligner-start">
      <y42-icon [icon]="importIcon" class="job-import full"></y42-icon>
    </div>
    <div class="font-normal ml-1 fs-07">
      {{ value.count }}
    </div>
  </div>
</div>
